export default __webpack_public_path__ + "static/media/logo-ae-homecenter.388ae208.svg";